import { ERROR_MODAL_TRANSLATIONS } from '@leprecoins/error-modal';
import { buildResources, LANGUAGES } from '@leprecoins/i18next';
import { LANDSCAPE_OVERLAY_TRANSLATIONS } from '@leprecoins/landscape-overlay';
import i18next from 'i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import I18NextHttpBackend, { HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const DEFAULT_LANGUAGE = LANGUAGES.en;

i18next
	.use(I18NextHttpBackend)
	.use(I18nextBrowserLanguageDetector)
	.use(initReactI18next)
	.init({
		partialBundledLanguages: true,
		resources: buildResources(
			LANDSCAPE_OVERLAY_TRANSLATIONS.namespace,
			ERROR_MODAL_TRANSLATIONS.namespace,
		),
		supportedLngs: Object.values(LANGUAGES),
		fallbackLng: DEFAULT_LANGUAGE,
		react: {
			useSuspense: true,
		},
		detection: {
			order: ['cookie', 'navigator'],
			caches: ['cookie'],
		},
		interpolation: {
			escapeValue: false,
		},
		backend: {
			loadPath: '/locales/{{lng}}/{{ns}}.json',
			requestOptions: {
				cache: 'no-store',
			},
		} satisfies HttpBackendOptions,
		ns: ['common', 'errors'],
	});

export { i18next };
